import type { ContactListDto } from '@features/contacts';

export function deduplicateContactLists (lists: ContactListDto[]): ContactListDto[] {
  return Array.from(lists.reduce((final: Set<ContactListDto>, current) => {
    const existingObjectInSet = Array.from(
      final.values()).some((list) => list.id === current.id);

    if (!existingObjectInSet) {
      final.add(current);
    }
    return final;
  }, new Set<ContactListDto>()));
}